import React, { useState } from 'react';
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  Snackbar,
  Alert,
  Stack,
  IconButton,
  Divider,
  Card,
  CardContent
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import { investorApi } from '../../api/api';
import { useSelector } from 'react-redux';
import GradientButton from '../common/GradiantButton';
import SecondaryButton from '../common/SecondaryButton';
import { useDispatch } from 'react-redux';
import { loginUser } from '../../redux/reducers/userReducer';

const EnquiryModal = ({ open, onClose, propertyData, type, selectedFlat }) => {
  const dispatch = useDispatch();
  const userId = useSelector((state) => state.user.userId);
  const userData = useSelector((state) => state.user);
  const { firstName, lastName, Email, Mobilenumber } = useSelector((state) => state.user);

  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [isEditMode, setIsEditMode] = useState(false);

  const [profileForm, setProfileForm] = useState({
    firstName,
    lastName,
    Email,
    Mobilenumber,
  });


  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleSubmit = async () => {
    if (!message.trim()) {
      setSnackbarMessage('Please enter your enquiry message');
      setSnackbarSeverity('warning');
      setSnackbarOpen(true);
      return;
    }

    setIsSubmitting(true);
    try {
      const payload = {
        userId: userId,
        message: message.trim(),
        flat_id: selectedFlat,
        ...(type === 3
          ? { ApartmentId: propertyData }
          : { propertyId: propertyData })
      };

      await investorApi.addHelpMessage(payload);
      setSnackbarMessage('Enquiry submitted successfully! Our team will contact you within 24 hours.');
      setSnackbarSeverity('success');
      setSnackbarOpen(true);
      setMessage('');

      setTimeout(() => {
        onClose();
      }, 2000);

    } catch (error) {
      console.error('Enquiry submission error:', error);
      setSnackbarMessage(
        error.response?.data?.message ||
        'Failed to submit enquiry. Please try again later.'
      );
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setIsSubmitting(false);
    }
  };


  const handleEditProfile = () => {
    setIsEditMode(true);
  };

  const handleProfileChange = (e) => {
    const { name, value } = e.target;
    setProfileForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSaveProfile = async () => {


    try {
      const res = await investorApi.updateProfile(userData.userId, {
        FirstName: profileForm.firstName,
        LastName: profileForm.lastName,
        Email: profileForm.Email,
        Mobilenumber: profileForm.Mobilenumber,
      });

      if (res.status === 200) {
        dispatch(
          loginUser({
            user: {
              id: userData.userId,
              firstName: profileForm.firstName,
              lastName: profileForm.lastName,
              avatar: userData.avatar,
              role: userData.role,
              wallet: userData.wallet,
              Email: profileForm.Email,
              Mobilenumber: profileForm.Mobilenumber,
              isSubscribed: userData.isSubscribed,
              isKyc: userData.isKyc,
              refferal_code: userData.user_refferal_code,
              isVerified: userData.isVerified,
            },
          })
        );

        setIsEditMode(false);
        setSnackbarMessage("Profile updated successfully");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
      }
    } catch (error) {
      setSnackbarMessage("Failed to update profile");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };
  return (
    <>
      <Modal
        open={!!open}
        onClose={!isSubmitting ? onClose : undefined}
        closeAfterTransition
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '90%', sm: '80%', md: 500 },
          maxWidth: 500,
          maxHeight: '90vh',
          overflow: 'auto',
          bgcolor: 'background.paper',
          boxShadow: 24,
          borderRadius: 2,
          p: { xs: 2, md: 3 },
          outline: 'none'
        }}>
          {/* Modal Header */}
          <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 3
          }}>
            <Typography variant="h5" fontWeight={600}>
              Submit Enquiry
            </Typography>
            <IconButton
              onClick={onClose}
              disabled={isSubmitting}
              size="small"
              sx={{ color: 'text.secondary' }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          <Divider sx={{ mb: 3 }} />

          {/* User Information */}


          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              mb: 1,
              gap: 2
            }}
          >
            {!isEditMode ? (
              <Card
                variant="outlined"
                sx={{
                  mb: 3,
                  borderRadius: 2,
                  borderColor: 'divider',
                  backgroundColor: 'grey.50',
                  width: "100%"
                }}
              >
                <CardContent sx={{ p: 2 }}>
                  <Box sx={{
                    display: 'flex',
                    // flexDirection:"column",
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    mb: 1,
                  }}>

                    <Typography variant="h6" fontWeight={600} gutterBottom>
                      {firstName} {lastName}
                    </Typography>
                    <Button
                      variant="outlined"
                      size="small"
                      startIcon={<EditIcon />}
                      onClick={handleEditProfile}
                      sx={{
                        minWidth: 'auto',
                        px: 2
                      }}
                    >
                      Edit
                    </Button>


                  </Box>
                  <Box>
                    <Stack spacing={1}>
                      <Typography
                        variant="body2"
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1
                        }}
                      >
                        <span style={{ fontWeight: 500 }}>Email:</span>
                        {Email}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1
                        }}
                      >
                        <span style={{ fontWeight: 500 }}>Phone:</span>
                        {Mobilenumber}
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{
                          color: 'warning.main',
                          mt: 0.5,
                          display: 'block'
                        }}
                      >
                        Please verify your mobile number before submitting the enquiry
                      </Typography>
                    </Stack>
                  </Box>
                </CardContent>
              </Card>
            ) : (

              <>
                <Stack spacing={1} width="100%">
                  <Stack direction="row" spacing={1} mb={1}>
                    <TextField
                      size="small"
                      label="First Name"
                      name="firstName"
                      value={profileForm.firstName}
                      onChange={handleProfileChange}
                      fullWidth
                    />
                    <TextField
                      size="small"
                      label="Last Name"
                      name="lastName"
                      value={profileForm.lastName}
                      onChange={handleProfileChange}
                      fullWidth
                    />
                  </Stack>

                  <TextField
                    size="small"
                    label="Email"
                    name="Email"
                    value={profileForm.Email}
                    onChange={handleProfileChange}
                    fullWidth
                    sx={{ marginTop: 1 }}
                  />

                  <TextField
                    size="small"
                    label="Mobile Number"
                    name="Mobilenumber"
                    value={profileForm.Mobilenumber}
                    onChange={handleProfileChange}
                    fullWidth
                    sx={{ margin: 1 }}
                  />

                  <Stack direction="row" spacing={2} justifyContent="flex-end" sx={{ mt: 2 }}>
                    <Button
                      variant="outlined"
                      onClick={() => {
                        setIsEditMode(false);
                        setProfileForm({ firstName, lastName, Email, Mobilenumber });
                      }}
                    >
                      Cancel
                    </Button>

                    <Button
                      variant="contained"
                      onClick={handleSaveProfile}
                    >
                      Save
                    </Button>
                  </Stack>
                </Stack>

              </>

            )}

          </Box>



          {/* Enquiry Form */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle1" fontWeight={600} gutterBottom>
              Enquiry Details
            </Typography>
            <TextField
              label="Your Message *"
              multiline
              rows={5}
              fullWidth
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              disabled={isSubmitting}
              placeholder="Please provide details about your enquiry, including any specific questions or requirements..."
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 2,
                }
              }}
            // helperText="Maximum 500 characters"
            // inputProps={{ maxLength: 500 }}
            />
            {/* <Typography 
              variant="caption" 
              color="text.secondary" 
              sx={{ 
                display: 'block',
                textAlign: 'right',
                mt: 1
              }}
            >
              {message.length}/500
            </Typography> */}
          </Box>

          {/* Action Buttons */}
          <Stack
            direction="row"
            spacing={2}
            justifyContent="flex-end"
            sx={{ mt: 4, pt: 2, borderTop: 1, borderColor: 'divider' }}
          >
            <SecondaryButton
              text='Cancel'
              onClick={onClose}
              disabled={isSubmitting}
              width={{ xs: '40%', sm: '30%' }}
            />
            <GradientButton
              text={isSubmitting ? 'Submitting...' : 'Submit Enquiry'}
              onClick={handleSubmit}
              disabled={isSubmitting || !message.trim()}
              loading={isSubmitting}
              width={{ xs: '60%', sm: '40%' }}
            />
          </Stack>
        </Box>
      </Modal>

      {/* Snackbar Notification */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{
            width: '100%',
            boxShadow: 3,
            borderRadius: 2
          }}
        >
          <Typography variant="body2">
            {snackbarMessage}
          </Typography>
        </Alert>
      </Snackbar>
    </>
  );
};

export default EnquiryModal;